export const modules = {
    BLOG: 'BLOG',
    ABOUT_IO: 'LEARN_ABOUT_IO',
    LIVING_CANCER: 'LIVING_WITH_CANCER',
    HELP_LINE: 'HELP_LINE',
    DISTRESS_SCREENER: 'DISTRESS_SCREENER',
    IOTRACKER: 'IOTRACKER',
    REGISTRY: 'REGISTRY',
    LOCAL_RESOURCES: 'LOCAL_RESOURCES',
    CUSTOM_SURVEYS: 'CUSTOM_SURVEYS'
};

export const errorMessages = {
    invalidCredentials: 'Invalid Credentials',
    loginNoConnection: 'Connection Error'
};

export const surveysBlocks = {
    symptomTracker: {
        name: 'My Side Effect Checklist'
    },
    distressScreener: {
        name: 'CancerSupportSource®'
    },
    custom: {
        name: 'Custom'
        }
};

export const passwordErrors = {
    minLength: {
        id: 'minLength',
        description: '12 characters minimum'
    },
    digit: {
        id: 'digit',
        description: 'One number'
    },
    upperCase: {
        id: 'upperCase',
        description: 'One uppercase letter'
    },
    lowerCase: {
        id: 'lowerCase',
        description: 'One lowercase letter'
    },
    specialCharacter: {
        id: 'specialCharacter',
        description: 'One special character [@#$%^&+=!()]'
    },
    blankSpace: {
        id: 'blankSpace',
        description: 'No white spaces'
    }
};

export const passwordErrorsArray = [
    passwordErrors.minLength,
    passwordErrors.digit,
    passwordErrors.upperCase,
    passwordErrors.lowerCase,
    passwordErrors.specialCharacter,
    passwordErrors.blankSpace,
];
